import React, { useState, useEffect } from "react"
import "./index.scss"
import { Link } from "gatsby"
import logoWhite from "../Icons/PSALogoWhite.svg"

const selectLogo = (path, expanded, logoWhite, img, scrollPosition) => {
  if (path === "/" || path === "/home") {
    return scrollPosition > 75 && !expanded ? (
      <img src={img} alt="home" />
    ) : (
      <img src={logoWhite} />
    )
  } else {
    return expanded ? <img src={logoWhite} /> : <img src={img} />
  }
}

const LinkItem = ({ item, path }) => {
  const { linkUrl, linkLabel } = item
  const smallLabel = linkUrl.toLowerCase()
  const cleanPath = path && path.replace("-", " ")
  return (
    <li className="nav-item">
      <Link
        className={`nav-link ${item.isThisAButton === true && "btn"} ${
          cleanPath && cleanPath?.includes(smallLabel.replace("-", " ")) && "current"
        }`}
        to={`${linkUrl}`}
      >
        {linkLabel}
      </Link>
    </li>
  )
}

const DropdownItem = ({ item, path }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const { linkLabel, linkUrl, dropdownLinks } = item
  const smallLabel = linkLabel.toLowerCase()
  const cleanPath = path && path?.replace("-", " ")

  const mouseEnter = () => {
    setDropdownOpen(true)
  }

  const mouseLeave = () => {
    setDropdownOpen(false)
  }

  return (
    <li
      className="dropdown nav-item"
      onMouseEnter={mouseEnter}
      onMouseLeave={mouseLeave}
    >
      <Link
        to={`${linkUrl}`}
        type="button"
        id="languageSelector"
        aria-expanded="false"
        data-bs-toggle="dropdown"
        className={`dropdown-button dropdown-toggle ${
          cleanPath && cleanPath?.includes(smallLabel) && "current"
        }`}
      >
        {linkLabel}
      </Link>

      <ul className={`dropdown-menu ${dropdownOpen ? "open" : null}`}>
        {dropdownLinks?.map(link => (
          <li className="dropdown-item" key={link.linkLabel}>
            <Link className="dropdown-link" to={`${link.linkUrl}`}>
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </li>
  )
}

export default function Nav({ navData, path, setSearchEngineVisible }) {
  // Use States --------
  const [expanded, setExpanded] = useState(false)
  // Sticky Nav handlers are here
  const [scrollPosition, setScrollPosition] = useState(0)

  const handleScroll = () => {
    if (typeof window !== "undefined") {
      const position = window.pageYOffset
      setScrollPosition(position)
    }
  }
  // Use effect for sticky nav
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handleScroll)
      return () => {
        window.removeEventListener("scroll", handleScroll)
      }
    }
  }, [])

  // Data ---------
  const img = navData.headerLogo.url
  const navLinks = navData.navItems[0].navLinks

  // Event Handlers -----
  const handleNavClick = () => {
    setExpanded(!expanded)
  }

  return (
    <nav
      className={`
        navbar navbar-expand-lg 
        ===PATH IS==>${path}
        ${path === "/" || path === "/home" ? "home-nav" : null} 
        ${expanded && "expanded"} 
        ${(scrollPosition > 75 && (path === "/" || path === "/home")) ? "sticky-nav" : null}
      `}
    >
      <Link className="navbar-brand" to="/">
        {selectLogo(path, expanded, logoWhite, img, scrollPosition)}
      </Link>

      <button
        type="button"
        data-target="#navNav"
        aria-expanded="false"
        aria-controls="navNav"
        data-toggle="collapse"
        className="navbar-toggler"
        aria-label="Toggle navigation"
        onClick={() => handleNavClick()}
      >
        <span
          className={` ${expanded ? "open-toggle " : null} navbar-toggler-icon`}
        ></span>
      </button>

      <div
        className={` ${expanded ? "show" : null} collapse navbar-collapse`}
        id="navNav"
      >
        <ul className="navbar-nav mr-auto">
          {navLinks?.map(link =>
            !link.typeOfLink ? (
              <LinkItem key={link.LinkLabel} item={link} path={path} />
            ) : (
              <DropdownItem key={link.LinkLabel} item={link} path={path} />
            )
          )}
          <li
            className="search-icon"
            onClick={() => setSearchEngineVisible(true)}
          >
            <svg
              width="28"
              height="30"
              viewBox="0 0 28 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.4211 12.2105C20.4211 16.7451 16.7451 20.4211 12.2105 20.4211C7.67598 20.4211 4 16.7451 4 12.2105C4 7.67598 7.67598 4 12.2105 4C16.7451 4 20.4211 7.67598 20.4211 12.2105ZM18.3897 22.7444C16.5771 23.81 14.4652 24.4211 12.2105 24.4211C5.46684 24.4211 0 18.9542 0 12.2105C0 5.46684 5.46684 0 12.2105 0C18.9542 0 24.4211 5.46684 24.4211 12.2105C24.4211 15.251 23.3098 18.0318 21.4713 20.1692L27.3616 26.0595C28.1426 26.8405 28.1426 28.1068 27.3616 28.8879C26.5805 29.6689 25.3142 29.6689 24.5332 28.8879L18.3897 22.7444Z"
              />
            </svg>
          </li>
        </ul>
      </div>
    </nav>
  )
}
